const ELIGIBLE_STATUSES = ['unlinked', 'not_linked', 'pending'];

// Matriz de decision de /activacionhbo (TBRFRE-2360 §2.2 + estados en frio).
// Funcion pura: el primer caso que aplica gana.
export const resolveHboCommunicationDestination = ({
  hasSession,
  hydrated,
  hydrationTimedOut,
  isAdmin,
  region,
  flagEnabled,
  hasHboSubscription,
  statusSettled,
  status,
  statusTimedOut,
}) => {
  if (!hasSession) return 'login';
  if (!hydrated) return hydrationTimedOut ? 'home' : 'wait';
  if (!isAdmin) return 'home';
  if (!region) return 'home';
  if (!flagEnabled) return 'home';
  if (!hasHboSubscription) return 'home';
  if (!statusSettled) return statusTimedOut ? 'home' : 'wait';

  return ELIGIBLE_STATUSES.includes(status) ? 'render' : 'home';
};
